import React from 'react';
import 'antd/dist/antd.css';
import { Spin, Space } from 'antd';

const Loader = () => (
  <Space size="middle" className="centred">
    <Spin size="large" />
  </Space>
);

export default Loader;
